var path = 'areas/shared/views/interrupt-fields/interrupt_Unknown.html';
var html = "<div class=\"alert alert-danger\">Unknown field type: {{ element.properties.Type }}</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/interrupt-fields/interrupt_Unknown.html
// module id = 968
// module chunks = 1